import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Employee } from 'src/app/models/Employees';
import { AuthService } from 'src/app/services/auth.service';
import { StateDistrictList } from 'src/app/services/StateDistrictList';
import { UtilityService } from 'src/app/util/utility.service';
import { UtilityTs } from 'src/app/util/utilityTs';

@Component({
  selector: 'app-rule-box',
  templateUrl: './rule-box.component.html',
  styleUrls: ['./rule-box.component.scss'],
})
export class RuleBoxComponent implements OnInit {
  districtService = new StateDistrictList();
  popupHeight = "300px";
  @Input() empId: string;
  @Input() rule: string[] = [];
  @Input() type: string;
  emp: Employee = new Employee();
  @Output() closePopup = new EventEmitter();
  @Output() onSave = new EventEmitter();

  utilityService: UtilityService = new UtilityService();
  valueType: string = 'String';

  variable: string;
  operator: string;
  value: string;

  selectedState: string;

  valueList: any[] = [];
  variableList: any[] = [
    { name: "State", value: "user.user_pd.state" },
    { name: "District", value: "user.user_pd.district" },
    { name: "Town", value: "user.user_pd.town" },
    { name: "Area", value: "user.user_pd.area" },
    { name: "Profession", value: "user.user_pd.profession" },
    { name: "Occupation", value: "user.user_pd.occupation" },
    { name: "Education", value: "user.user_pd.education" },
    { name: "Gotra", value: "user.user_pd.sub_community" },
    { name: "Tag", value: "user.user_pd.tag" },
    { name: "Marital Status", value: "user.user_pd.marital" },
  ]
  operatorList: any[] = [
    { name: "Equals", value: "=" },
    { name: "Not Equals", value: "!=" },
    { name: "More than", value: ">" },
    { name: "More than Equals", value: ">=" },
    { name: "Less than", value: "<" },
    { name: "Less than Equals", value: "<=" }
  ]

  constructor(private auth: AuthService) { }

  ngOnInit() { }

  onSelectVariable(variable) {
    console.log(variable);
    this.valueType = 'String';
    switch (variable) {
      case "user.user_pd.marital": this.valueList = this.utilityService.maritalStatusList; break;
      case "user.user_pd.tag": this.valueList = this.auth.business.tag; break;
      case "user.user_pd.sub_community": this.valueList = this.auth.business.category; break;
      case "user.user_pd.education": this.valueList = this.utilityService.educationObjectList; this.valueType = 'Object'; break;
      case "user.user_pd.occupation": this.valueList = this.utilityService.occupationObjectList; this.valueType = 'Object'; break;
      case "user.user_pd.profession": this.valueList = this.utilityService.professionObjectList; this.valueType = 'Object'; break;
      // case "user.user_pd.area": this.valueList = this.utilityService.maritalStatusList; break;
      // case "user.user_pd.town": this.valueList = this.utilityService.maritalStatusList; break;
      // case "user.user_pd.district": this.valueList = this.districtService.districtList; break;
      case "user.user_pd.state": this.valueList = this.districtService.stateList; break;
    }
  }

  onSelectState(state) {
    new StateDistrictList().createDistrictList(state)
  }

  onClickRemove() {

  }
  onClickSave() {
    this.rule.push(this.variable, this.operator, this.value);
    this.onSave.emit(this.rule);
  }
}
